import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import WebhookRoundedIcon from '@mui/icons-material/WebhookRounded';
import { Button, Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { ReactNode } from 'react';
import { ColoredIcon } from '../ColoredIconAndChip';
import { TOrganisationNotification, TOrganisationNotificationType } from './type';

const NOTIFICATION_TYPE_ICON_MAPPING: { [type in TOrganisationNotificationType]: ReactNode } = {
  EMAIL: <AlternateEmailRoundedIcon sx={{ fontSize: 12 }} />,
  WEBHOOK: <WebhookRoundedIcon sx={{ fontSize: 12 }} />,
};

export const OrganisationNotificationListItem = ({
  item,
  onRemoveNotification,
}: Readonly<{ item: TOrganisationNotification; onRemoveNotification: (id: string) => void }>) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={tokens.spacing2xs}
      flexWrap="wrap"
    >
      <Stack direction="row" alignItems="center" gap={tokens.spacing2xs} flexWrap="wrap">
        {NOTIFICATION_TYPE_ICON_MAPPING[item.type]} <Typography>{item.detail}</Typography>
      </Stack>
      <Button
        variant="text"
        startIcon={<ColoredIcon iconName="deleteRounded" />}
        onClick={() => {
          onRemoveNotification(item.id);
        }}
        color="error"
      />
    </Stack>
  );
};
